<template>
  <div class="popup-main">
    <el-dialog
      :title="selfData.id ? '编辑印章' : '新增印章'"
      width="500px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <e-form
          ref="refForm"
          :config="formConfig"
          :column="formColumn"
          :data.sync="selfData"
          :rules="rules"
        />
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {},
      formConfig: {
        inline: false,
        width: '100%'
      },
      formColumn: [
        {
          type: 'text',
          title: '印章名称',
          field: 'name',
          required: true
        },
        {
          type: 'select',
          title: '印章类型',
          field: 'yin_zhang_type',
          required: true,
          options: [
            {
              key: '公司章',
              val: '公司章'
            },
            {
              key: '合同章',
              val: '合同章'
            },
            {
              key: '财务章',
              val: '财务章'
            }
          ]
        },
        {
          type: 'switch',
          title: '状态',
          field: 'is_open',
          activeText: '启用',
          inActiveText: '禁用'
        },
        {
          type: 'text',
          title: '备注',
          field: 'bei_zhu'
        },
        {
          type: 'upload_image',
          title: '印章图片',
          field: 'tu_pian',
          limit: 1,
          isDelete: true
        }
      ],
      rules: {
        name: [{ required: true, message: '请输入印章名称' }],
        yin_zhang_type: [{ required: true, message: '请选择印章类型' }]
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.selfData = this.$util.deepCopy(this.data)
  },
  methods: {
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$api({
            method: 'post',
            url: '/admin/gcvip/yinZhang/saveOrUpdate',
            data: this.selfData
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.popupCancel()
                this.$emit('success')
                this.$message.success('保存成功')
              }
            })
            .catch((error) => {
              this.$message.error(error)
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
